import { render, staticRenderFns } from "./AcountingAutomatic.vue?vue&type=template&id=18abbf25&scoped=true"
import script from "./AcountingAutomatic.vue?vue&type=script&lang=js"
export * from "./AcountingAutomatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18abbf25",
  null
  
)

export default component.exports